<template>
    <router-view class="pa-2" @click:salle="goToSalle"></router-view>
</template>

<script>
export default {
  methods: {
    goToSalle (idSalle) {
      if (idSalle) {
        this.$router.push({ name: 'salleInfo', params: { id: idSalle } })
      }
    }
  }
}
</script>

<style>

</style>
